<template>
  <div>
    <v-chip class="border text-uppercase rounded-xxs grey-darken-1--text font-weight-bold">
      {{ $t('pilot') }}
    </v-chip>
    <div class="mt-6">
      {{ $t('videoCall.infoStep.perex') }}
    </div>
    <div class="my-6">
      <v-list class="pa-4 grey rounded">
        <v-list-item
          v-for="(item, index) in bulletPoints"
          :key="index"
          class="pa-0 align-flexstart"
          :class="{ 'mt-4': index > 0 }"
        >
          <v-img :src="$asset(`img/icons/${item.icon}.svg`)" contain width="48" />
          <div class="ml-4 text-left">{{ item.text }}</div>
        </v-list-item>
      </v-list>
    </div>
    <p
      v-for="(item, index) in texts"
      :id="'videoCallLegals' + `[${index}]`"
      :key="index"
      class="grey-darken-1--text text-body-small text-left"
      v-html="item"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  name: 'VideoCallInfoStep',
  mixins: [dashboardPartnerData],
  data() {
    return {
      bulletPoints: [
        {
          icon: 'register',
          text: this.$t('videoCall.infoStep.list.first')
        },
        {
          icon: `calendar/date-${new Date().getDate()}`,
          text: this.$t('videoCall.infoStep.list.second')
        },
        {
          icon: 'doctor',
          text: this.$t('videoCall.infoStep.list.third')
        }
      ]
    };
  },
  computed: {
    isAllianz() {
      //hack for cs allianz legal document change, can be deleted when not needed
      return this.partnerData.url === 'allianzlegal' && this.$i18n.locale === 'cs';
    },
    allianzTexts() {
      //hack for cs allianz legal document change, can be deleted when not needed
      return [
        'Vezměte, prosím, na vědomí, že služba Videohovor s lékařem má pouze informativní charakter.',
        'Jedná se o obecné rady a informace z oblasti zdraví, nemocí či jiných zdravotních obtíží. Výše uvedené informace nemohou být považovány za určení individuální diagnózy, stanovení léčebného plánu či plánu prevence, a to zejména s ohledem na omezené možnosti online komunikace. Vzhledem k tomu, že informace od uživatele nemohou být úplné a tělesné vyšetření není možné, odpovědi jednotlivých lékařů se mohou v detailech lišit v závislosti na jejich zkušenostech a klinické praxi.',
        'Využití služby v žádném případě nenahrazuje osobní vyšetření lékařem. V případě zdravotních obtíží doporučujeme vyhledat lékařskou či jinou odbornou péči podle povahy potíží.'
      ];
    },
    texts() {
      const lokaliseTexts = this.$t('videoCall.infoStep.legal');
      if (this.isAllianz) {
        return [lokaliseTexts[0], ...this.allianzTexts];
      }

      return lokaliseTexts;
    }
  },
  mounted() {
    if (this.isAllianz) {
      const elements = document.querySelectorAll('[id^="videoCallLegals"]'); //hack for cs allianz legal document change, can be deleted when not needed
      elements.forEach((el, index) => {
        el.textContent = this.allianzTexts[index];
      });
    }
    this.setDialogTitle(this.$t('videoCall.infoStep.title'));
    this.setDialogLeftHeaderIcon('icons/phone-video.svg');
    this.setDialogButtons([
      {
        events: {
          click: () => {
            this.$emit('next-click');
          }
        },
        text: this.$t('videoCall.infoStep.button')
      }
    ]);
  },
  methods: {
    ...mapActions({
      setDialogTitle: 'staticForms/videoCall/infoStep/setDialogTitle',
      setDialogButtons: 'staticForms/videoCall/infoStep/setDialogButtons',
      setDialogLeftHeaderIcon: 'staticForms/videoCall/infoStep/setDialogLeftHeaderIcon'
    })
  }
};
</script>

<style scoped>
.v-chip {
  pointer-events: none;
}
</style>
